// extracted by mini-css-extract-plugin
export default {"button":"style_button__pEfPR","button-yellow":"style_button-yellow__t7Hdw","button-gray":"style_button-gray__ehkLQ"};